import { type TourStep } from '../../types/project-tour.types';
import { StepIdsEnum } from './projects-tour-enums';

export const NUM_REQUIRED_PRODUCTS = 3;
export const MOBILE_LEFT_OFFSET = 16;
export const MOBILE_SIDEBAR_LEFT_OFFSET = 8;

export const {
	TOUR_START,
	COPY_MOVE,
	COMPARE,
	ADD_TO_CART,
	NEW_GROUP,
	GROUP,
	SEARCH_FROM_PROJECTS,
	EDIT_PRODUCT,
	COMMENT,
	ORDERS_RETURNS,
	COMMUNICATION,
	PORTFOLIO,
	TOUR_END
} = StepIdsEnum;

export const TOOLBAR_DEFAULTS: Pick<TourStep, 'title' | 'topOffset' | 'leftOffset' | 'verticalPosition'> = {
	title: 'Project Toolbar',
	topOffset: 12,
	leftOffset: -8,
	verticalPosition: 'bottom'
};

export const GROUP_DEFAULTS: Pick<TourStep, 'title' | 'leftOffset' | 'verticalPosition'> = {
	title: 'Groups & Products',
	leftOffset: -8,
	verticalPosition: 'top'
};

export const MANAGEMENT_DEFAULTS: Pick<TourStep, 'title' | 'leftOffset' | 'verticalPosition'> = {
	title: 'Project Management Tools',
	leftOffset: -289,
	verticalPosition: 'top'
};
